import React, { useState } from 'react';
import {
  useDownloadValidationChecksComparisonFile,
  useListValidationChecksComparisons,
  validationChecksComparisonsKeys,
} from '~/data/validation-checks-comparisons/queries';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';
import { Button, TablePagination } from '@mui/material';
import { ComparisonTable } from '~/app/components/pages/auditor/admin-panel/validation-checks-comparison/table';
import { CreateComparisonModal } from '~/app/components/pages/auditor/admin-panel/validation-checks-comparison/create-comparison-modal';
import { useQueryClient } from '@tanstack/react-query';

export default function ValidationChecksComparisonPage() {
  const [isCreationModalOpen, setCreationModalOpen] = useState(false);
  const [queryParams, setQueryParams] = useQueryParams({
    offset: withDefault(NumberParam, 0),
    limit: withDefault(NumberParam, 10),
  });
  const queryClient = useQueryClient();
  const { data: comparisonList, isSuccess } = useListValidationChecksComparisons({
    offset: queryParams.offset,
    limit: queryParams.limit,
  });

  const { mutateAsync: downloadComparisonFile } = useDownloadValidationChecksComparisonFile();

  const comparisons = comparisonList?.items ?? [];

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: validationChecksComparisonsKeys.list(), exact: false });
    setCreationModalOpen(false);
  };

  return (
    <section>
      <div className="flex justify-end mb-3">
        <Button variant="contained" onClick={() => setCreationModalOpen(true)}>
          Create comparison
        </Button>
      </div>
      <ComparisonTable
        comparisons={comparisons}
        isSuccess={isSuccess}
        limit={queryParams.limit}
        downloadComparison={(id) => downloadComparisonFile({ comparisonId: id })}
      />
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={comparisonList?.count ?? 0}
        rowsPerPage={queryParams.limit}
        page={queryParams.offset / queryParams.limit}
        onPageChange={(e, page) => {
          setQueryParams({
            offset: page * queryParams.limit,
          });
        }}
        onRowsPerPageChange={(e) => {
          setQueryParams({
            limit: +e.target.value,
          });
        }}
      />
      <CreateComparisonModal
        open={isCreationModalOpen}
        onClose={() => setCreationModalOpen(false)}
        onSuccess={onSuccess}
      />
    </section>
  );
}
